import React from 'react';

import cn from 'classnames';
import { EmblaCarouselType } from 'embla-carousel';

import { Image } from '@shared/ui';

import cls from '../EmblaCarousel.module.css';

type PropType = {
    selected: boolean;
    index: number;
    emblaThumbsApi: EmblaCarouselType;
    emblaMainApi: EmblaCarouselType;
    photo: string;
    onThumbClick?: () => void;
};

export const Thumb: React.FC<PropType> = (props) => {
    const { selected, photo, emblaThumbsApi, index, emblaMainApi, onThumbClick } = props;

    const handleThumbClick = () => {
        if (!emblaMainApi || !emblaThumbsApi) return;
        emblaMainApi.scrollTo(index);
        onThumbClick?.();
    };

    return (
        <div
            className={cn(cls.emblaThumbsSlide, {
                [cls.emblaThumbsSlideSelected]: selected,
            })}
        >
            <div onClick={handleThumbClick} className={cls.emblaThumbsSlideNumber}>
                {/* <img src={photo} alt="" /> */}
                <Image src={photo} alt="" />
                {/* <img src={photo} alt="" /> */}
            </div>
        </div>
    );
};
